import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { logError } from 'commons/logger';
import PromotionBanner from 'components/consumer/promotion-banner';
import useContentfulPromotionContent from 'hooks/useContentfulPromotionContent';
const isDateLessThan5Days = dateString => {
  if (!dateString) {
    return false;
  }
  try {
    const date = new Date(dateString);
    const now = new Date();
    const difference = date.getTime() - now.getTime();
    if (difference < 5 * 24 * 3600 * 1000 && difference > 0) {
      return true;
    }
  } catch (err) {
    logError(err, 'Error while processing the endDate');
  }
  return false;
};
const PromotionBannerDynamic = () => {
  const $ = _c(14);
  const {
    loading,
    promotionData
  } = useContentfulPromotionContent();
  if (loading) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="min-h-[55px] max-[767px]:min-h-[70px]" />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== promotionData) {
    t0 = promotionData || {};
    $[1] = promotionData;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    alternateTitle,
    topBannerText,
    endDate,
    topBannerTextColor,
    topBannerBackgroundColor,
    topBannerBackgroundImage,
    secondaryBannerText
  } = t0;
  if (!alternateTitle) {
    return null;
  }
  let t1;
  if ($[3] !== endDate) {
    t1 = isDateLessThan5Days(endDate);
    $[3] = endDate;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== alternateTitle || $[6] !== endDate || $[7] !== secondaryBannerText || $[8] !== t1 || $[9] !== topBannerBackgroundColor || $[10] !== topBannerBackgroundImage || $[11] !== topBannerText || $[12] !== topBannerTextColor) {
    const promotion = {
      name: alternateTitle,
      discount: null,
      mainContent: alternateTitle,
      topBannerText,
      subContent: null,
      endDate,
      countDownFormat: "DD HH MM",
      countdownToggle: t1,
      backgroundImage: topBannerBackgroundImage,
      backgroundColor: topBannerBackgroundColor,
      backgroundHeight: "50px",
      secondaryBannerText,
      textColor: topBannerTextColor
    };
    t2 = <PromotionBanner config={promotion} />;
    $[5] = alternateTitle;
    $[6] = endDate;
    $[7] = secondaryBannerText;
    $[8] = t1;
    $[9] = topBannerBackgroundColor;
    $[10] = topBannerBackgroundImage;
    $[11] = topBannerText;
    $[12] = topBannerTextColor;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
};
export default PromotionBannerDynamic;